export default "__VITE_ASSET__BCOynsdi__"